import { useMemo, useState } from 'react';
import { formatCnpj, parseCnpj } from '@optefiscal/fiscal-domain';

/**
 * Inspetor de identificador fiscal.
 *
 * Funcionalidade real desta fundação: exercita o validador central de
 * `@optefiscal/fiscal-domain` — o mesmo código usado pela API Edge e, com o
 * mesmo algoritmo, pela função `public.fiscal_cnpj_is_valid` no banco.
 *
 * Serve de prova viva de que o produto aceita CNPJ alfanumérico desde a
 * fundação (Plano Oficial, seção 7).
 */
export function TaxIdInspector() {
  const [input, setInput] = useState('12.ABC.345/01DE-35');
  const result = useMemo(() => parseCnpj(input), [input]);

  return (
    <section className="of-card" aria-labelledby="inspector-title">
      <h2 className="of-card__title" id="inspector-title">
        Identificador fiscal
      </h2>
      <p className="of-card__hint">
        Validador central de CNPJ. Aceita o formato numérico legado e o formato alfanumérico com a
        mesma regra de dígito verificador — não existem dois caminhos.
      </p>

      <div className="of-field">
        <label className="of-label" htmlFor="cnpj">
          CNPJ
        </label>
        <input
          id="cnpj"
          className="of-input"
          value={input}
          spellCheck={false}
          autoComplete="off"
          onChange={(event) => setInput(event.target.value)}
          aria-describedby="cnpj-resultado"
        />
      </div>

      <div className="of-result" id="cnpj-resultado" role="status" aria-live="polite">
        {result.ok ? (
          <dl>
            <dt>Situação</dt>
            <dd>Válido</dd>
            <dt>Valor canônico</dt>
            <dd>{result.value}</dd>
            <dt>Máscara</dt>
            <dd>{formatCnpj(result.value)}</dd>
            <dt>Formato</dt>
            <dd>{result.format === 'alphanumeric' ? 'Alfanumérico' : 'Numérico (legado)'}</dd>
            <dt>Tipo armazenado</dt>
            <dd>text</dd>
          </dl>
        ) : (
          <dl>
            <dt>Situação</dt>
            <dd>Inválido</dd>
            <dt>Código</dt>
            <dd>{result.code}</dd>
            <dt>Motivo</dt>
            <dd style={{ fontFamily: 'var(--of-font-sans)' }}>{result.message}</dd>
          </dl>
        )}
      </div>

      <p className="of-footnote" style={{ marginTop: 'var(--of-space-4)', marginBottom: 0 }}>
        O erro é sempre explícito e classificado. Nenhuma entrada inválida é &ldquo;corrigida&rdquo;
        em silêncio.
      </p>
    </section>
  );
}
